<div class="footer">
    <span class="footer__text">Beta - v1.0.3 <br>© 2023 Made with ❤️ by Inbounds team</span>
</div>